import { get, post, put } from '../../../core/api/client';
import { API_ENDPOINTS } from '../../../core/api/endpoints';

const sanitizeLimit = (value) => {
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return 20;
  return Math.min(200, Math.max(1, Math.trunc(parsed)));
};

const sanitizeOffset = (value) => {
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return 0;
  return Math.max(0, Math.trunc(parsed));
};

/**
 * @param {number} clientId
 * @param {{limit?: number, offset?: number, deliveryStatus?: string}} params
 * @returns {Promise<Object>} 
 */
export const getLogs = async (clientId, params = {}) => {
  const limit = sanitizeLimit(params.limit ?? 20);
  const offset = sanitizeOffset(params.offset ?? 0);
  const deliveryStatus = String(params.deliveryStatus || "").trim().toLowerCase();

  const query = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });

  if (deliveryStatus) {
    query.set("delivery_status", deliveryStatus);
  }

  const endpoint = `${API_ENDPOINTS.LOGS.LIST_BY_CLIENT(clientId)}?${query.toString()}`;
  const response = await get(endpoint);

  if (response?.error) {
    return response;
  }

  const logs = Array.isArray(response?.logs)
    ? response.logs
    : Array.isArray(response?.data)
      ? response.data
      : Array.isArray(response)
        ? response
        : [];

  return {
    logs,
    total: Number(response?.total || logs.length),
    limit: Number(response?.limit || limit),
    offset: Number(response?.offset || offset),
  };
};

/**
 * @param {Object} logData 
 * @returns {Promise<Object>}
 */
export const createLog = async (logData) => {
  const response = await post(API_ENDPOINTS.LOGS.CREATE, logData);
  return response;
};

/**
 * @param {number} id 
 * @param {Object} logData 
 * @returns {Promise<Object>}
 */
export const updateLog = async (id, logData) => {
  const response = await put(
    API_ENDPOINTS.LOGS.UPDATE_BY_CLIENT_LOG_ID(id),
    logData,
  );
  return response;
};
